import {ProductState} from "./index";
import {AnyAction} from "redux";
import {
  CREATE_PRODUCT_BEGIN,
  CREATE_PRODUCT_FAILURE,
  CREATE_PRODUCT_SUCCESS,
  FETCH_PRODUCTS_BEGIN,
  FETCH_PRODUCTS_FAILURE,
  FETCH_PRODUCTS_SUCCESS,
  UPDATE_ITEM_IN_EDIT_MODE,
  UPDATE_PRODUCT_BEGIN,
  UPDATE_PRODUCT_FAILURE,
  UPDATE_PRODUCT_SUCCESS,
  DUPLICATE_PRODUCT_BEGIN,
  DUPLICATE_PRODUCT_FAILURE,
  DUPLICATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCTS_FILTER,
  FETCH_PRODUCT_STATUS_SUCCESS,
  IMPORT_FILE_BEGIN,
  IMPORT_FILE_FAILURE,
  IMPORT_FILE_SUCCESS,
  IMPORT_FILE_PROGRESS_STATUS,
  IMPORT_FILE_RESET_PROCESS,
  UPDATE_PRODUCTS
} from "../actions/products";
import {getObjectIndexByProperty, updateCollection, updateObject} from "../utils/miscUtils";
import {ProductDataItem} from "../types/StudioAPITypes";
import {PRODUCT_FILTER_PREFIX} from "../utils/constants";

const initialState: ProductState = {
  items: [],
  projectId: "",
  projectName: "",
  filter: "",
  itemInEditMode: "",
  fileImport: {
    status: "",
    progress: 0
  }
};

let product: ProductDataItem;

const products = (state: ProductState = initialState, action: AnyAction) => {
  switch(action.type) {
    case UPDATE_PRODUCTS:
      return updateObject(state, {
        items: action.items
      });
    case FETCH_PRODUCTS_SUCCESS:
      return updateObject(state, {
        items: action.payload.products.products,
        projectId: action.payload.products.id,
        projectName: action.payload.products.name
      });
    case DUPLICATE_PRODUCT_SUCCESS:
      product = action.payload.product;
      return updateObject(state, {
        items: state.items.concat([product]),
        filter:"",
      });
    case IMPORT_FILE_SUCCESS:
      product = action.payload.product;
      return updateObject(state, {
        items: state.items.concat([product]),
        filter:"",
        fileImport: {
          progress: 100,
          status: "SUCCESS"
        }
      });
    case CREATE_PRODUCT_SUCCESS:
      product = action.payload.product;
      return updateObject(state, {
        items: state.items.concat([product]),
        itemInEditMode: product.id,
        filter:""
      });
    case UPDATE_PRODUCT_SUCCESS:
      product = action.payload.product;
      const index = getObjectIndexByProperty<ProductDataItem, string>(state.items, "id", product.id);

      if (index !== -1) {
          return updateObject(state, {
            items: updateCollection<ProductDataItem>(state.items, product, index),
            filter: "",
          });
      }
      return state;
    case FETCH_PRODUCT_STATUS_SUCCESS:
        let productStatusObject = action.payload.productStatus;
        let progressPct = action.progressPct;
        const indexForStatusUpdate = getObjectIndexByProperty<ProductDataItem, string>(state.items, "id", productStatusObject.id.toString());

        if (indexForStatusUpdate !== -1) {
          let product = state.items[indexForStatusUpdate];

          let updatedProduct = updateObject(product, {
            status: productStatusObject.productStatus,
            progressPct: progressPct
          });

          return updateObject(state, {
            items: updateCollection<ProductDataItem>(state.items, updatedProduct, indexForStatusUpdate),
            filter: ""
          });
        }
      return state;
    case UPDATE_ITEM_IN_EDIT_MODE:
      return updateObject(state, {
        itemInEditMode: action.id
      });
    case UPDATE_PRODUCTS_FILTER:
      return updateObject(state,{
        filter: action.filter
      });
    case FETCH_PRODUCTS_BEGIN:
      return updateObject(state,{
        projectName: "",
        filter: (localStorage.getItem(PRODUCT_FILTER_PREFIX + action.projectId) !== null) ? localStorage.getItem(PRODUCT_FILTER_PREFIX + action.projectId) : "",
      });
    case IMPORT_FILE_PROGRESS_STATUS:
      return updateObject(state, {
        fileImport: {
          progress: action.payload.percent,
          status: "IN_PROGRESS"
        }
      });
    case IMPORT_FILE_FAILURE:
      return updateObject(state, {
        fileImport: {
          progress: 100,
          status: "FAILURE"
        }
    });
    case IMPORT_FILE_BEGIN:
      return  updateObject(state, {
        fileImport: {
          progress: 0,
          status: "IN_PROGRESS"
        }
      });
    case IMPORT_FILE_RESET_PROCESS:
      return updateObject(state, {
        fileImport: {
          progress: 0,
          status: ""
        }
      });
    case FETCH_PRODUCTS_FAILURE:
    case CREATE_PRODUCT_BEGIN:
    case CREATE_PRODUCT_FAILURE:
    case UPDATE_PRODUCT_BEGIN:
    case UPDATE_PRODUCT_FAILURE:
    case DUPLICATE_PRODUCT_FAILURE:
    default:
      return state;
  }
};


export default products;
